import {addContactConstants} from '../../../../../../../util/uiconstants';

export default (checkboxList, toggleContctList, userList, tagsSelectedList, customColumnsList, toggleGroupRiskAssessmentAccess, userLevelAccess) => {
	var body = {};
	let contactsBody = [];
	let contactList = [...userList];
	let views = [];
	for (var checkbox of checkboxList) {
		if (checkbox.checked) views.push(checkbox.key);
	}
	const tags = formatTags(tagsSelectedList?.filter((tag) => tag.checked === true));
	let customColumns = customColumnsList?.filter((col) => col.value !== null);
	customColumns = formatCustomColumns(customColumns);
	for (var contact of contactList) {
		var contacts = {
			emailAddress: contact.emailAddress,
			name: contact.name,
			lastName: contact.lastName,
			phone: contact?.phone,
			location: contact?.location,
			userId: contact.userId,
			isInternal: contact.isInternal,
			roleId: contact?.roleId,
			roleName: contact?.roleName,
			serviceLineName: contact?.serviceLineName,
			serviceLineId: contact?.serviceLineId,
			isIgnored: false, //From add contact this value should be false. Ignore is use in potential contacts to remove.
			engagements: contact?.engagements || []
		};
		contactsBody.push(contacts);
	}
	body[addContactConstants.contacts] = contactsBody;
	body[addContactConstants.dashboardViews] = views;
	body[addContactConstants.hasViews] = !!views?.length;
	body[addContactConstants.tags] = tags || [];
	body[addContactConstants.customColumns] = customColumns || [];
	body[addContactConstants.contactList] = {hasAccess: !!toggleContctList};
	body[addContactConstants.groupRiskAssessment] = {
		hasAccess: contactList.some((m) => !m.isInternal) ? false : !!toggleGroupRiskAssessmentAccess
	};
	body[addContactConstants.userLevelAccess] = userLevelAccess;
	return body;
};
const formatCustomColumns = (customColumns) => {
	const newCustomColumns = customColumns?.map((column) => ({
		id: column.id,
		name: column.name,
		options: [{id: column.value.id, option: column.value.name}],
		columnType: 'radio'
	}));
	return newCustomColumns;
};

const formatTags = (tags) => {
	const newTags = tags?.map((tag) => ({
		id: tag.id,
		key: tag.key,
		name: tag.name,
		color: tag.color,
		isCustom: tag.isCustom
	}));
	return newTags;
};
